import React from "react";
import { EntityContextInterface } from "module/entity/context/entity/EntityContext";

export type CertificationSessionContextInterface = EntityContextInterface;

const CertificationSessionContext = React.createContext(
  <CertificationSessionContextInterface>{}
);

export default CertificationSessionContext;
